import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom'
import Header from "../Component/Header";
import LazyLoad from "react-lazyload";
const SchoolUniform = () => {
    useEffect(() => {
        document.title = 'School Uniform  -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li> Academics </li>
                 <li>School Uniform </li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1> School Uniform  </h1>
                    </div>
                </div>
                <div className="row schoolinfo schooluni"> 
                
              <div className="col-xl-3 col-lg-4 col-md-6">
                <LazyLoad>
                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/schooluniform1.jpg"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/schooluniform1.jpg" className="schoollib img-fluid" alt="TAFS" /></a> 
                </LazyLoad>  
            </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <LazyLoad>
                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/schooluniform2.jpg"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/schooluniform2.jpg" className="schoollib img-fluid" alt="TAFS" /></a> 
                </LazyLoad>  
            </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <LazyLoad>
                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/schooluniform3.jpg"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/schooluniform3.jpg" className="schoollib img-fluid" alt="TAFS" /></a> 
                </LazyLoad>  
            </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <LazyLoad>
                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/schooluniform4.jpg"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/schooluniform4.jpg" className="schoollib img-fluid" alt="TAFS" /></a> 
                </LazyLoad>  
            </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <LazyLoad>
                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/schooluniform5.jpg"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/schooluniform5.jpg" className="schoollib img-fluid" alt="TAFS" /></a> 
                </LazyLoad>  
            </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <LazyLoad>
                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/schooluniform6.jpg"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/schooluniform6.jpg" className="schoollib img-fluid" alt="TAFS" /></a> 
                </LazyLoad>  
            </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <LazyLoad>
                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/schooluniform7.jpg"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/schooluniform7.jpg" className="schoollib img-fluid" alt="TAFS" /></a> 
                </LazyLoad>  
            </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <LazyLoad>
                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/schooluniform8.jpg"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/schooluniform8.jpg" className="schoollib img-fluid" alt="TAFS" /></a> 
                </LazyLoad>  
            </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <LazyLoad>
                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/schooluniform9.jpg"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/schooluniform9.jpg" className="schoollib img-fluid" alt="TAFS" /></a> 
                </LazyLoad>  
            </div>
                   
                       <h6>Standardisation Of The Air Force School Uniform</h6>
                       <div className="col-lg-6">
                          <div className="linktab"><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/SchoolUniform.pdf" target="_blank">  School Uniform </Link></div>
                        </div> 
                      </div>
            </div>
        </div>
     </>
  )
}

export default SchoolUniform